import React, { useState } from 'react';
import { TrophyIcon, StarIcon, ArrowUpIcon, AwardIcon, ZapIcon, TrendingUpIcon } from 'lucide-react';
const topPerformers = [{
  rank: 1,
  name: 'Sarah Kim',
  role: 'Sr. Loan Originator',
  avatar: 'SK',
  loans: 23,
  volume: '$9.2M',
  badge: 'Top Originator',
  month: 'February',
  color: '#2B8DC4'
}, {
  rank: 2,
  name: 'Carlos Mendez',
  role: 'Branch Manager',
  avatar: 'CM',
  loans: 19,
  volume: '$7.8M',
  badge: 'Branch Leader',
  month: 'February',
  color: '#1A2B3C'
}, {
  rank: 3,
  name: 'Priya Rajan',
  role: 'Loan Originator',
  avatar: 'PR',
  loans: 15,
  volume: '$6.1M',
  badge: 'Rising Star',
  month: 'February',
  color: '#1E6FA0'
}];
const allAchievers = [{
  name: 'Derek Liu',
  role: 'Processor',
  avatar: 'DL',
  achievement: 'Fastest Close — 12 days',
  icon: ZapIcon,
  color: '#2B8DC4'
}, {
  name: 'Marcus Thompson',
  role: 'Lead Processor',
  avatar: 'MT',
  achievement: '100% Accuracy Rate — Q4',
  icon: StarIcon,
  color: '#1A2B3C'
}, {
  name: 'Lisa Martinez',
  role: 'Training Manager',
  avatar: 'LM',
  achievement: 'Team Certification Leader',
  icon: AwardIcon,
  color: '#2B8DC4'
}, {
  name: 'James Park',
  role: 'Underwriter',
  avatar: 'JP',
  achievement: '48hr Turnaround Streak',
  icon: TrendingUpIcon,
  color: '#1A2B3C'
}, {
  name: 'Alex Chen',
  role: 'Loan Originator',
  avatar: 'AC',
  achievement: 'New Hire of the Quarter',
  icon: StarIcon,
  color: '#2B8DC4'
}, {
  name: 'Maria Santos',
  role: 'Processor',
  avatar: 'MS',
  achievement: 'Zero Error Month — Jan',
  icon: AwardIcon,
  color: '#1A2B3C'
}];
const milestones = [{
  label: 'Company Loans Closed',
  value: '1,247',
  change: '+18% YoY',
  color: '#2B8DC4'
}, {
  label: 'Total Volume',
  value: '$487M',
  change: '+22% YoY',
  color: '#1A2B3C'
}, {
  label: 'Avg. Close Time',
  value: '26 days',
  change: '-4 days YoY',
  color: '#2B8DC4'
}, {
  label: 'Team Members',
  value: '124',
  change: '+12 this year',
  color: '#1A2B3C'
}];
const rankColors = ['#E8A020', '#A0AECB', '#C47A3A'];
const rankLabels = ['🥇', '🥈', '🥉'];
export function HallOfFame() {
  const [activeTab, setActiveTab] = useState<'monthly' | 'alltime'>('monthly');
  return <div style={{
    maxWidth: 1280,
    margin: '0 auto'
  }} data-id="element-258">
      {/* Hero Banner */}
      <div style={{
      borderRadius: 16,
      padding: '32px 40px',
      marginBottom: 24,
      position: 'relative',
      overflow: 'hidden',
      background: 'linear-gradient(118deg, #0D1B2A 0%, #1E6FA0 45%, #0D1B2A 100%)',
      minHeight: 160
    }} data-id="element-259">
        <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'repeating-linear-gradient(-55deg, transparent, transparent 18px, rgba(255,255,255,0.025) 18px, rgba(255,255,255,0.025) 36px)',
        pointerEvents: 'none'
      }} data-id="element-260" />
        <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '40%',
        height: '100%',
        background: 'linear-gradient(118deg, transparent 0%, rgba(43,141,196,0.2) 100%)',
        clipPath: 'polygon(30% 0, 100% 0, 100% 100%, 0% 100%)',
        pointerEvents: 'none'
      }} data-id="element-261" />
        <div style={{
        position: 'absolute',
        right: 40,
        top: '50%',
        transform: 'translateY(-50%)',
        opacity: 0.07,
        pointerEvents: 'none'
      }} data-id="element-262">
          <TrophyIcon size={160} color="white" data-id="element-263" />
        </div>
        <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 4,
        background: 'linear-gradient(90deg, #2B8DC4 0%, #3FA8E0 60%, transparent 100%)'
      }} data-id="element-264" />
        <div style={{
        position: 'relative',
        zIndex: 1
      }} data-id="element-265">
          <div style={{
          fontSize: 12,
          color: 'rgba(255,255,255,0.5)',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          marginBottom: 6
        }} data-id="element-266">
            Recognition
          </div>
          <h2 style={{
          fontSize: 32,
          fontWeight: 900,
          color: '#FFFFFF',
          margin: '0 0 6px',
          fontStyle: 'italic',
          letterSpacing: '-0.04em',
          lineHeight: 1
        }} data-id="element-267">
            Hall of Fame 🏆
          </h2>
          <p style={{
          color: 'rgba(255,255,255,0.6)',
          fontSize: 14,
          margin: '0 0 16px',
          fontWeight: 500
        }} data-id="element-268">
            Celebrating the people who make Swift exceptional.
          </p>
          <div style={{
          display: 'flex',
          gap: 10,
          flexWrap: 'wrap'
        }} data-id="element-269">
            <span style={{
            padding: '5px 14px',
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 800,
            background: '#2B8DC4',
            color: 'white',
            fontStyle: 'italic'
          }} data-id="element-270">
              February 2025
            </span>
            <span style={{
            padding: '5px 14px',
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 600,
            background: 'rgba(255,255,255,0.1)',
            color: 'rgba(255,255,255,0.8)',
            border: '1px solid rgba(255,255,255,0.15)'
          }} data-id="element-271">
              $487M total volume
            </span>
          </div>
        </div>
      </div>

      {/* Milestone Stats */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 16,
      marginBottom: 24
    }} data-id="element-272">
        {milestones.map(m => <div key={m.label} style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '20px 22px',
        border: '1px solid #E4EAF6',
        borderTopColor: m.color,
        borderTopWidth: 3,
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
        position: 'relative',
        overflow: 'hidden'
      }} data-id="element-273">
            <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: 60,
          height: 60,
          background: `${m.color}06`,
          clipPath: 'polygon(100% 0, 100% 100%, 0 0)'
        }} data-id="element-274" />
            <div style={{
          marginBottom: 8
        }} data-id="element-275">
              <span style={{
            fontSize: 11,
            fontWeight: 700,
            color: m.color,
            background: `${m.color}12`,
            padding: '2px 8px',
            borderRadius: 4,
            fontStyle: 'italic'
          }} data-id="element-276">
                {m.change}
              </span>
            </div>
            <div style={{
          fontSize: 34,
          fontWeight: 900,
          color: '#1A2B3C',
          letterSpacing: '-0.04em',
          fontStyle: 'italic',
          lineHeight: 1,
          marginBottom: 8,
          position: 'relative',
          display: 'inline-block'
        }} data-id="element-277">
              {m.value}
              <div style={{
            position: 'absolute',
            bottom: -4,
            left: 0,
            width: '60%',
            height: 3,
            borderRadius: 2,
            background: m.color
          }} data-id="element-278" />
            </div>
            <div style={{
          fontSize: 12,
          color: '#5A6A8A',
          fontWeight: 600,
          marginTop: 8
        }} data-id="element-279">
              {m.label}
            </div>
          </div>)}
      </div>

      {/* Tab Toggle */}
      <div style={{
      display: 'flex',
      gap: 8,
      marginBottom: 20
    }} data-id="element-280">
        {(['monthly', 'alltime'] as const).map(tab => <button key={tab} onClick={() => setActiveTab(tab)} style={{
        padding: '8px 20px',
        borderRadius: 8,
        fontSize: 13,
        fontWeight: 800,
        fontStyle: 'italic',
        cursor: 'pointer',
        border: 'none',
        transition: 'all 0.15s',
        background: activeTab === tab ? '#2B8DC4' : '#FFFFFF',
        color: activeTab === tab ? '#FFFFFF' : '#5A6A8A',
        boxShadow: activeTab === tab ? '0 2px 8px rgba(43,141,196,0.3)' : '0 1px 3px rgba(13,27,42,0.08)'
      }} data-id="element-281">
            {tab === 'monthly' ? 'Monthly Leaders' : 'All-Time Achievers'}
          </button>)}
      </div>

      {activeTab === 'monthly' ? <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 20
    }} data-id="element-282">
          {/* Podium */}
          <div style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '24px',
        border: '1px solid #E4EAF6',
        borderTopWidth: 3,
        borderTopColor: '#2B8DC4',
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
      }} data-id="element-283">
            <h3 style={{
          fontSize: 15,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 20px',
          fontStyle: 'italic',
          letterSpacing: '-0.02em'
        }} data-id="element-284">
              Top 3 — February
            </h3>
            <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 12
        }} data-id="element-285">
              {topPerformers.map((p, i) => <div key={p.rank} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            padding: '14px 16px',
            borderRadius: 10,
            background: i === 0 ? '#EBF5FB' : '#F4F8FC',
            border: `1px solid ${i === 0 ? '#2B8DC4' : '#E4EAF6'}`
          }} data-id="element-286">
                  <div style={{
              fontSize: 22,
              width: 32,
              textAlign: 'center',
              flexShrink: 0
            }} data-id="element-287">
                    {rankLabels[i]}
                  </div>
                  <div style={{
              width: 44,
              height: 44,
              borderRadius: 10,
              background: p.color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 14,
              fontWeight: 900,
              color: 'white',
              transform: 'skewX(-4deg)',
              flexShrink: 0
            }} data-id="element-288">
                    {p.avatar}
                  </div>
                  <div style={{
              flex: 1
            }} data-id="element-289">
                    <div style={{
                fontSize: 14,
                fontWeight: 900,
                color: '#1A2B3C',
                fontStyle: 'italic',
                letterSpacing: '-0.02em'
              }} data-id="element-290">
                      {p.name}
                    </div>
                    <div style={{
                fontSize: 11,
                color: '#5A6A8A'
              }} data-id="element-291">
                      {p.role}
                    </div>
                  </div>
                  <div style={{
              textAlign: 'right'
            }} data-id="element-292">
                    <div style={{
                fontSize: 13,
                fontWeight: 900,
                color: '#2B8DC4',
                fontStyle: 'italic'
              }} data-id="element-293">
                      {p.volume}
                    </div>
                    <div style={{
                fontSize: 11,
                color: '#A0AECB'
              }} data-id="element-294">
                      {p.loans} loans
                    </div>
                  </div>
                  <span style={{
              fontSize: 10,
              fontWeight: 800,
              padding: '3px 8px',
              borderRadius: 4,
              background: '#EBF5FB',
              color: '#2B8DC4',
              letterSpacing: '0.04em',
              whiteSpace: 'nowrap'
            }} data-id="element-295">
                    {p.badge}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Spotlight */}
          <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-296">
            <div style={{
          borderRadius: 12,
          padding: '24px',
          background: 'linear-gradient(135deg, #0D1B2A 0%, #1E6FA0 100%)',
          position: 'relative',
          overflow: 'hidden',
          flex: 1
        }} data-id="element-297">
              <div style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '50%',
            height: '100%',
            background: 'linear-gradient(135deg, transparent, rgba(43,141,196,0.25))',
            clipPath: 'polygon(40% 0, 100% 0, 100% 100%, 0 100%)'
          }} data-id="element-298" />
              <div style={{
            position: 'relative',
            zIndex: 1
          }} data-id="element-299">
                <div style={{
              fontSize: 10,
              fontWeight: 800,
              color: '#3FA8E0',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              marginBottom: 12
            }} data-id="element-300">
                  ⚡ Employee Spotlight
                </div>
                <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              marginBottom: 12
            }} data-id="element-301">
                  <div style={{
                width: 52,
                height: 52,
                borderRadius: 12,
                background: 'linear-gradient(135deg, #2B8DC4, #0D1B2A)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 16,
                fontWeight: 900,
                color: 'white',
                transform: 'skewX(-4deg)'
              }} data-id="element-302">
                    SK
                  </div>
                  <div data-id="element-303">
                    <div style={{
                  fontSize: 18,
                  fontWeight: 900,
                  color: 'white',
                  fontStyle: 'italic',
                  letterSpacing: '-0.03em'
                }} data-id="element-304">
                      Sarah Kim
                    </div>
                    <div style={{
                  fontSize: 12,
                  color: 'rgba(255,255,255,0.5)'
                }} data-id="element-305">
                      Sr. Loan Originator · Phoenix, AZ
                    </div>
                  </div>
                </div>
                <p style={{
              fontSize: 13,
              color: 'rgba(255,255,255,0.7)',
              margin: '0 0 16px',
              lineHeight: 1.6
            }} data-id="element-306">
                  23 loans closed in February — a new company record. Sarah's
                  dedication to her clients and relentless follow-through sets
                  the standard for the entire team.
                </p>
                <div style={{
              display: 'flex',
              gap: 8
            }} data-id="element-307">
                  <span style={{
                fontSize: 11,
                fontWeight: 700,
                padding: '4px 10px',
                borderRadius: 5,
                background: 'rgba(43,141,196,0.3)',
                color: '#3FA8E0'
              }} data-id="element-308">
                    23 Loans
                  </span>
                  <span style={{
                fontSize: 11,
                fontWeight: 700,
                padding: '4px 10px',
                borderRadius: 5,
                background: 'rgba(255,255,255,0.1)',
                color: 'rgba(255,255,255,0.7)'
              }} data-id="element-309">
                    $9.2M Volume
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div> /* All-Time Achievers Grid */ : <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 14
    }} data-id="element-310">
          {allAchievers.map((a, i) => {
        const Icon = a.icon;
        return <div key={i} style={{
          background: '#FFFFFF',
          borderRadius: 12,
          padding: '18px 20px',
          border: '1px solid #E4EAF6',
          borderTopWidth: 3,
          borderTopColor: a.color,
          boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
          display: 'flex',
          gap: 12,
          alignItems: 'flex-start'
        }} data-id="element-311">
                <div style={{
            width: 44,
            height: 44,
            borderRadius: 10,
            background: a.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 13,
            fontWeight: 900,
            color: 'white',
            transform: 'skewX(-4deg)',
            flexShrink: 0
          }} data-id="element-312">
                  {a.avatar}
                </div>
                <div style={{
            flex: 1
          }} data-id="element-313">
                  <div style={{
              fontSize: 13,
              fontWeight: 900,
              color: '#1A2B3C',
              fontStyle: 'italic',
              letterSpacing: '-0.02em',
              marginBottom: 2
            }} data-id="element-314">
                    {a.name}
                  </div>
                  <div style={{
              fontSize: 11,
              color: '#5A6A8A',
              marginBottom: 8
            }} data-id="element-315">
                    {a.role}
                  </div>
                  <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }} data-id="element-316">
                    <Icon size={12} color={a.color} data-id="element-317" />
                    <span style={{
                fontSize: 11,
                fontWeight: 700,
                color: a.color
              }} data-id="element-318">
                      {a.achievement}
                    </span>
                  </div>
                </div>
              </div>;
      })}
        </div>}
    </div>;
}